import { useState, useEffect } from 'react';
import logo from '../../assets/logo.png';
import './Header.css';

const Header = () => {
  const [toggle, setToggle] = useState(false);
  const [activeNav, setActiveNav] = useState('#home');

  // Function to handle scroll and update active section
  const handleScroll = () => {
    // Add scroll-header class to header when scrolling down
    const header = document.querySelector(".header");
    if (window.scrollY >= 80) {
      header.classList.add("scroll-header");
    } else {
      header.classList.remove("scroll-header");
    }

    // Get all sections that have an ID defined
    const sections = document.querySelectorAll('section[id]');
    
    // Get current scroll position
    const scrollY = window.pageYOffset;

    // Loop through sections to get height, top and ID values for each
    sections.forEach(current => {
      const sectionHeight = current.offsetHeight;
      const sectionTop = current.offsetTop - 50;
      const sectionId = '#' + current.getAttribute('id');
      
      // If our current scroll position enters the space where current section is
      if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
        setActiveNav(sectionId);
      }
    });
  };

  // Set up scroll event listener when component mounts
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    
    // Clean up event listener when component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className="header">
      <nav className="nav container">
        <img src={logo} alt="LOGO" className='moetaz__logo' />
        
        {/* Menu Section */}
        <div className={toggle ? "nav__menu show-menu" : "nav__menu"}>
          <ul className="nav__list grid">
            <li className="nav__item">
              <a 
                href="#home" 
                onClick={() => setActiveNav('#home')} 
                className={activeNav === '#home' ? "nav__link active-link" : "nav__link"}
              >
                <i className="uil uil-estate nav__icon"></i>Home
              </a>
            </li>
            <li className="nav__item">
              <a 
                href="#about" 
                onClick={() => setActiveNav('#about')} 
                className={activeNav === '#about' ? "nav__link active-link" : "nav__link"}
              >
                <i className="uil uil-user nav__icon"></i>About
              </a>
            </li>
            <li className="nav__item">
              <a 
                href="#skills" 
                onClick={() => setActiveNav('#skills')} 
                className={activeNav === '#skills' ? "nav__link active-link" : "nav__link"}
              >
                <i className="uil uil-file-alt nav__icon"></i>Skills
              </a>
            </li>
            <li className="nav__item">
              <a 
                href="#qualification" 
                onClick={() => setActiveNav('#qualification')} 
                className={activeNav === '#qualification' ? "nav__link active-link" : "nav__link"}
              >
                <i className="uil uil-briefcase-alt nav__icon"></i>Qualification
              </a>
            </li>
            <li className="nav__item">
              <a 
                href="#projects" 
                onClick={() => setActiveNav('#projects')} 
                className={activeNav === '#projects' ? "nav__link active-link" : "nav__link"}
              >
                <i className="uil uil-scenery nav__icon"></i>Projects
              </a>
            </li>
            <li className="nav__item">
              <a 
                href="#contact" 
                onClick={() => setActiveNav('#contact')} 
                className={activeNav === '#contact' ? "nav__link active-link" : "nav__link"}
              >
                <i className="uil uil-message nav__icon"></i>Contact
              </a>
            </li>
          </ul>
          <i
            className="uil uil-times nav__close"
            onClick={() => setToggle(false)} // Close menu
          ></i>
        </div>
        
        {/* Toggle Button */}
        <div
          className="nav__toggle"
          onClick={() => setToggle(!toggle)} // Open/close menu
        >
          <i className="uil uil-apps"></i>
        </div>
      </nav>
    </header>
  );
};

export default Header;